import ItemBank from "@/modules/itembank/components/ItemBank";
import ItemBankForm from "@/modules/itembank/components/Form";
import ListReport from "@/modules/itembank/components/ListReport";

export default [
    {
        path: "/items",
        name: "ItemBank",
        component: ItemBank,
    },
    {
        path: "/item-form",
        name: "ItemBankForm",
        component: ItemBankForm,
    },
    {
        path: "/list-report",
        name: "ListReport",
        component: ListReport,
    },
];



// WEBPACK FOOTER //
// ./src/modules/itembank/router/itembank.js